// extracted by mini-css-extract-plugin
export default {"container":"Form__container___AsVtN"};